import Style from "./empowermentAndUnstoppablePopup.module.scss";
import CloseIcon from "@mui/icons-material/Close";
import { TasksEnum } from "../../js/tasksEnum";

const SuccessfullEmpowermentPopup = ({
  title,
  selectedSession,
  isEmopwerment,
  currentSession,
  showButton = false,
  handlePopup,
  isMaintenance,
  month,
}) => {
  const handleButtonClick = () => {
    handlePopup?.(true);
  };

  return (
    <div className={`${Style.popup} mt-3 pb-5`}>
      {
        <div
          onClick={handleButtonClick}
          className={`d-flex justify-content-end cursor-pointer ${Style.cross}`}
        >
          <CloseIcon />
        </div>
      }
      <div
        className={`d-flex flex-column align-items-center text-center  ${Style.content}`}
      >
        <h5 className="mb-5">
          Successfully Completed
          {!isMaintenance && ` Emotional Empowerment  ${title}`}
          {isMaintenance && " Emotional Empowerment Maitenance Session"}
          {month > 0 && ` Month ${month}`}
        </h5>
        <p className="text-justify">
          Congratulations on completing your session. You’ll have up to seven
          days relief. But in severe cases of mental crisis, complete a session
          every three days.
        </p>
        <p className="text-justify">
          Don't forget to read the lesson and tips. Practice the activities and
          take your brain on a date. Reach out to us if you need assistance.
        </p>
        <p className="text-justify">
          If you are at risk of harming yourself, seek immediate professional
          help. 
        </p>
        {!isMaintenance && showButton && (
          <div className="mt-5">
            <button
              onClick={handleButtonClick}
              className="white-btn cursor-pointer w-100 mt-1"
            >
              {`${
                currentSession >= 14
                  ? "Pre-Session Maintenance"
                  : "Pre-Session " + `${currentSession + 1}`
              }  Audio`}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
export default SuccessfullEmpowermentPopup;
